import { computed } from 'vue';
import { Routes } from '@/models/router/router.interface';
import { IUploadedFile } from '@/models/imports.interface';
import importedDataPresenter from '@/presenters/imported-data-presenter';
import store from '@/store';

export default class SubmitButtonCode {
	public isDisabled = computed((): boolean => {
		return this.selectedFileUpload.value === null;
	});

	private selectedFileUpload = computed((): IUploadedFile | null => {
		return store.getters.selectedFileUpload();
	});

	private errorMessage = computed((): string => {
		return store.getters.errorMessage();
	});

	public async wrapUpProcess(): Promise<void> {
		await this.storeImport();

		if (this.errorMessage.value) {
			return;
		}

		// Reset the uploaded file before navigating to the next page.
		store.mutations.selectFileUpload(null);
		store.mutations.setCurrentRoute(Routes.OVERVIEW);
	}

	private async storeImport(): Promise<void> {
		if (!this.selectedFileUpload.value) {
			return;
		}

		await importedDataPresenter.postCSV(this.selectedFileUpload.value.contents);
	}
}
